import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import logo from "../images/utopia/TEXTONLY.png";

import IGV from "../images/utopia/IGV.jpg";
import OGV from "../images/utopia/OGV.jpg";
import IGT from "../images/utopia/IGT.jpg";
import OGT from "../images/utopia/OGT.jpg";

import list from "../data/utopia.json";
import { saveAs } from "file-saver";
import ReactGA from "react-ga";

const Utopia = () => {
  const [email, setEmail] = useState();
  const [emailInvalid, setEmailInvalid] = useState();
  const [foundMember, setFoundMember] = useState();
  const [color, setColor] = useState();
  const [bg, setBg] = useState();

  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
    hidden: {
      visibility: "hidden",
    },
  };

  const bgColors = {
    red: "bg-red",
    purple: "bg-purple",
    orange: "bg-orange",
    teal: "bg-teal",
    green: "bg-green",
    yellow: "bg-yellow",
  };

  const textColors = {
    red: "text-red",
    purple: "text-purple",
    orange: "text-orange",
    teal: "text-teal",
    green: "text-green",
    yellow: "text-yellow",
  };

  const logoRef = useRef(null);
  const titleRef = useRef(null);
  const contentRef = useRef(null);
  const stage1 = useRef(null);

  const spinLogo = (e) => {
    gsap.fromTo(
      "#catalyst-logo",
      {
        scale: 1,
      },
      {
        scale: 1.2,
        yoyo: true,
        repeat: 1,
        duration: 0.2,
        ease: "expo.inOut",
      }
    );
  };

  const revealFunction = () => {
    ReactGA.event({
      category: "UTOPIA",
      action: "reveal",
      label: "reveal_l",
    });

    let found = false;
    list.forEach((member) => {
      if (member.email === email) {
        setFoundMember(member);
        setEmailInvalid(false);
        let t2 = gsap.timeline({ repeat: 0 });

        t2.to(stage1.current, {
          ease: "expo.inOut",
          autoAlpha: 0,
          display: "none",
          y: 100,
          duration: 1,
        });

        t2.to(".stage2-stagger", {
          y: 0,
          ease: "expo.inOut",
          scale: 1,
          autoAlpha: 1,
          duration: 1.5,
          stagger: 0.12,
          delay: -0.7,
        });

        switch (member.function) {
          case "iGV B2B & VD":
            setColor("red");
            setBg(IGV);
            break;
          case "iGV IR":
            setColor("purple");
            setBg(IGV);
            break;
          case "iGT B2B & VD":
            setColor("red");
            setBg(IGT);
            break;
          case "iGT IR":
            setColor("purple");
            setBg(IGT);
            break;
          case "oGT B2C":
            setColor("orange");
            setBg(OGT);
            break;
          case "oGT PS":
            setColor("teal");
            setBg(OGT);
            break;
          case "oGV B2C":
            setColor("green");
            setBg(OGV);
            break;
          case "oGV PS":
            setColor("yellow");
            setBg(OGV);
            break;

          default:
            break;
        }
        found = true;
        return true;
      }
    });
    if (!found) {
      setEmailInvalid(true);
    }
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const downloadBG = () => {
    saveAs(bg, "UTOPIABG.jpg");
  };

  useEffect(() => {
    ReactGA.pageview(window.location.pathname);

    gsap.set(".stage2-stagger", {
      autoAlpha: 0,
      y: 60,
      scale: 0,
    });

    gsap.set(".sc-title", {
      autoAlpha: 0,
      y: -60,
    });

    let t1 = gsap.timeline({ repeat: 0 });

    t1.from(logoRef.current, {
      ease: "expo.inOut",
      autoAlpha: 0,
      scale: 0.5,
      y: 100,
      duration: 2,
    });

    t1.from(
      titleRef.current,
      {
        ease: "expo.inOut",
        autoAlpha: 0,
        y: 80,
        duration: 2,
      },
      "<"
    );

    t1.from(
      contentRef.current,
      {
        ease: "expo.inOut",
        autoAlpha: 0,
        y: 80,
        duration: 2,
      },
      "<"
    );

    t1.to(
      ".sc-title",
      {
        y: 0,
        ease: "expo.out",
        scale: 1,
        autoAlpha: 1,
        duration: 1,
        delay: 1,
      },
      "<"
    );
  }, []);

  return (
    <div className="w-full min-h-screen text-white pb-8" style={styles.blackbg}>
      <div className="w-full flex flex-col justify-center items-center pt-32">
        <img src={logo} alt="catalyst-logo" ref={logoRef} id="catalyst-logo" className="w-full max-w-sm el" style={styles.hidden} onClick={(e) => spinLogo(e)} />

        <div style={styles.hidden} ref={contentRef}>
          <div className="my-2 text-3xl font-thin sc-title text-center" style={{ color: "#037ef3" }}>
            <div className="mb-4" ref={stage1}>
              <div className="mb-2 mt-6">
                <input
                  className="w-full px-3 py-2 text-lg leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline bg-black"
                  type="email"
                  placeholder="Enter Your Email Address"
                  onChange={handleChange}
                  autoComplete="false"
                />
                <div className={`text-xs text-red mt-4 ${!emailInvalid && "hidden"}`}>Invalid Email</div>
              </div>
              <button className="mt-4 text-lg bg-blue text-white px-4 py-2 rounded-md" onClick={() => revealFunction()}>
                Show Me My Function
              </button>
            </div>

            <div className="mb-4">
              <div className="text-xl stage2-stagger mt-6 mb-1" style={styles.hidden}>
                {foundMember?.name}
              </div>
              <div className="text-xl stage2-stagger my-1 text-white" style={styles.hidden}>
                Your function is...
              </div>
              <div className={`text-4xl stage2-stagger my-1 font-bold ${textColors[color]}`} style={styles.hidden}>
                {foundMember?.function}
              </div>
              <div className="text-xl stage2-stagger my-1" style={styles.hidden}>
                Congratulations!
              </div>
              <button className={`mt-4 text-lg ${bgColors[color]} text-white px-4 py-2 stage2-stagger rounded-md`} onClick={() => downloadBG()} style={styles.hidden}>
                Download Zoom BG
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Utopia;
